import Firebase from "../../firebasehelper";

export const setFaviconAndTitle = (brandName, brandIcon) => {
  // set doc title
  document.title = brandName;

  // set icon as favicon
  const link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/png";
  link.rel = "icon";
  link.href = brandIcon;
  document.getElementsByTagName("head")[0].appendChild(link);
};

export const checkIfEmailExists = async (email) => {
  try {
    const signInMethods = await Firebase.getAuth().fetchSignInMethodsForEmail(
      email
    );
    return signInMethods && signInMethods.length > 0;
  } catch (err) {
    console.log("checkIfEmailExists() error", err);
  }
};

export const createNewAdminAccount = async (
  email,
  password,
  firstName,
  brandId,
  adminType
) => {
  try {
    // 1. create account via Firebase auth
    await Firebase.addAgency(email, password).then((uid) => {
      let data = {
        uid: uid,
        username: firstName,
        email,
        role: 2,
        brand: brandId,
        approved: true,
        type: adminType,
        createdAt: Firebase.getDB().ServerValue.TIMESTAMP,
      };

      // 2. create new admin account
      Firebase.writeAgencydata(uid, data);
    });

    return { success: true };
  } catch (err) {
    console.log("createAdminAccount() error", err);
    return { success: false };
  }
};



// WEBPACK FOOTER //
// ./src/screens/AdminRegistration/utils.js